import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Title: {
    id: 'specializations_title',
    defaultMessage: 'Specializations',
  },
  Specializations: {
    id: 'label_specializations',
    defaultMessage: 'Specializations',
  },
  SpecializationsHelp: {
    id: 'help_specializations',
    defaultMessage: 'Uses specializations set on content if not set here.',
  },
  Close: {
    id: 'Close',
    defaultMessage: 'Close',
  },
});
